import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import App from './App';
import AddBranchLocationLayer from './components/AddBranchLocationLayer';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/add-branch-location" element={<AddBranchLocationLayer />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);
